import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  classGroups: {
    'font-size': [{ text: ['xsm', 'md'] }]
  }
})
export default twMerge;